// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29GJo","type":"styles_type__1IIog","choices":"styles_choices__22xpS"};